import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Avatar,
  Typography,
  Input,
  Modal,
  message,
} from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Spinner from "../components/common/Spinner/Spinner";
import jwtDecode from "jwt-decode";
import {
  deleteMultipleActivityTypes,
  getAllActivityTypes,
} from "../utils/activityTypeApi";

const { Title } = Typography;

const columns = [
  {
    title: "ACTIVITY NAME",
    dataIndex: "activityName",
    key: "activityName",
    width: "32%",
  },
  {
    title: "ACTIVITY TYPE ID",
    key: "activityTypeId",
    dataIndex: "activityTypeId",
  },
];

function ActivityTypes() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(false);
  const [activityTypes, setActivityTypes] = useState();
  const [query, setQuery] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const data = activityTypes
    ?.filter((activityType) =>
      query === ""
        ? activityType
        : activityType.activityName
            ?.toLowerCase()
            .includes(query.toLowerCase())
    )
    .map((activityType) => {
      return {
        key: activityType?.id,
        activityName: (
          <>
            <Avatar.Group>
              <div className="avatar-info">
                <Title level={5}>{activityType?.activityName}</Title>
              </div>
            </Avatar.Group>{" "}
          </>
        ),
        activityTypeId: (
          <>
            <div className="ant-employed">
              <span>{activityType?.id}</span>
              <Link
                style={{ marginLeft: "10px", color: "#1EC8FF" }}
                to={`activity-type/${activityType?.id}`}
              >
                Edit
              </Link>
            </div>
          </>
        ),
      };
    });

  const fetchActivityTypes = async () => {
    try {
      setLoading(true);
      const response = await getAllActivityTypes();
      setActivityTypes(response);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleBulkDelete = async () => {
    try {
      await deleteMultipleActivityTypes(selectedRowKeys);
      messageApi.open({
        type: "success",
        content: "Activity types deleted successfully",
      });
      setSelectedRowKeys([]);
      setIsDeleteModalOpen(false);
      fetchActivityTypes();
    } catch (error) {
      console.log(error);
      messageApi.open({
        type: "error",
        content: "Failed to delete activity types. Please try again later.",
      });
      setIsDeleteModalOpen(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    fetchActivityTypes();
  }, []);

  return (
    <>
      {contextHolder}
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Activity Types"
              extra={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  <Input
                    style={{
                      marginRight: "10px",
                      width: "200px",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                    size="small"
                    prefix={<SearchOutlined className="site-form-item-icon" />}
                    placeholder="Search activity type"
                    onChange={(e) => setQuery(e.target.value)}
                  />
                  {selectedRowKeys.length > 0 && (
                    <Button
                      danger
                      style={{
                        marginBottom: "10px",
                        marginTop: "10px",
                        marginRight: "10px",
                      }}
                      onClick={() => setIsDeleteModalOpen(true)}
                    >
                      Delete Selected ({selectedRowKeys.length})
                    </Button>
                  )}
                  <NavLink
                    to="/add-activity-type"
                    style={{
                      marginBottom: "10px",
                      marginTop: "10px",
                      marginRight: "10px",
                    }}
                  >
                    <Button type="secondary" className="tag-primary">
                      <PlusOutlined />
                      Add Activity Type
                    </Button>
                  </NavLink>
                </div>
              }
            >
              <div className="table-responsive">
                {loading ? (
                  <Spinner />
                ) : (
                  <Table
                    style={{ padding: "10px" }}
                    columns={columns}
                    dataSource={data}
                    pagination={true}
                    className="ant-border-space"
                    rowSelection={rowSelection}
                  />
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal
        title="Warning"
        open={isDeleteModalOpen}
        okText="Delete"
        okType="danger"
        onOk={handleBulkDelete}
        onCancel={() => setIsDeleteModalOpen(false)}
      >
        <p>
          Are you sure you want to delete {selectedRowKeys.length} activity
          type(s)?
        </p>
      </Modal>
    </>
  );
}

export default ActivityTypes;
